import { getUrl } from 'helpers';
import styled, { css } from 'styled-components';

export const Container = styled.div<GameCardContainerProps>`
    height: 90px;
    perspective: 1000px;
    position: relative;
    width: 70px;

    ${({ $bare }) =>
        !$bare &&
        css`
            &:before {
                background-color: #467348;
                border-radius: 8px;
                border: 3px dashed #507e53;
                content: '';
                height: 100%;
                left: 0;
                position: absolute;
                top: 0;
                width: 100%;
            }
        `}
`;

const Side = styled.div<GameCardSideProps>`
    backface-visibility: hidden;
    border-radius: 8px;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform-style: preserve-3d;
    transition:
        border 0.2s ease-in-out,
        transform 0.2s ease-in-out;
    width: 100%;
    z-index: 1;
`;

export const Back = styled(Side)`
    background-image: url('${getUrl('/assets/cards/back.png')}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 70px 90px;
    transform: rotateY(${({ $show }) => ($show ? 0 : -180)}deg);
`;

export const Front = styled(Side)`
    align-items: center;
    background:
        linear-gradient(#ffffff, #ffffff) padding-box,
        linear-gradient(to right, #fbe67b, #fcfbe7, #f7d14e, #d4a041) border-box;
    border: ${({ $highlight }) => ($highlight ? 7 : 0)}px solid transparent;
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 700;
    gap: 4px;
    justify-content: center;
    line-height: 1;
    opacity: ${({ $debug, $show }) => ($debug && !$show ? 0.5 : 1)};
    position: relative;
    text-transform: uppercase;
    transform: rotateY(${({ $debug, $show }) => ($debug || $show ? 0 : 180)}deg);
`;
